// Today's descriptions of Sortera Factory for the sign-in page, written by Claude on the server.
// Read before anyone has signed in, so no token; nothing on failure, as the page has its own.

import type { SignInTextDto } from "../types/index.ts";
import { apiUrl } from "./http.ts";

export async function fetchSignInTexts(): Promise<SignInTextDto[]> {
  try {
    const response = await fetch(apiUrl("/v1/sign-in-texts"));
    return response.ok ? ((await response.json()) as SignInTextDto[]) : [];
  } catch {
    return [];
  }
}
